module.exports = __webpack_public_path__ + "img/img_4.ac66eddb.png";